import { rootApi } from "../../api/rootApi";

const userActivityApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserActivity: builder.mutation({
            query: (params) => {
                return {
                    method: "GET",
                    url: `/tenant/user-activity/?${
                        params?.filters
                            ? new URLSearchParams(params?.filters)?.toString()
                            : ""
                    }`,
                    headers: {
                        slug: params.tenant_id,
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                    },
                };
            },
        }),
        getUserActivityExportData: builder.mutation({
            query: (params) => {
                return {
                    method: "GET",
                    url: `/tenant/user-activity/export`,
                    headers: {
                        slug: params.tenant_id,
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                    },
                };
            },
        }),
    }),
});

export const {
    useGetUserActivityMutation,
    useGetUserActivityExportDataMutation,
} = userActivityApi;
